// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header {\r\n  width:100%;\r\n  text-align: right;\r\n  color:blue;\r\n  height: 60px;\r\n  padding-top: 5px;\r\n  padding-right: 5px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
